import React from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Paper, 
  useMediaQuery,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const RefundPolicy = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 3,
       backgroundColor: 'rgb(239, 231, 221)',
        backgroundImage: 'url(https://www.transparenttextures.com/patterns/cream-paper.png)',
        backgroundRepeat: 'repeat'
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 900,
          height: isMobile ? '90vh' : '80vh',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
          overflow: 'hidden',
          //backgroundColor: 'rgba(239, 231, 221, 0.9)'
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2,
            position: 'sticky',
            top: 0,
            backgroundColor: 'inherit',
            zIndex: 1,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Refund Policy
          </Typography>
        </Box>

        {/* Scrollable Content */}
        <Box
          sx={{
            overflowY: 'auto',
            flex: 1,
            px: 3,
            pt: 2,
            pb: 1
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            1. Overview
          </Typography>
          <Typography variant="body2" paragraph>
            At Property Pincoder, we strive to provide excellent service and ensure customer satisfaction...
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            2. Eligibility for Refunds
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary="Refunds may be considered only for payments made for premium services..." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Requests must be submitted within 30 days from the date of payment." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Refunds are not provided for transactions related to property purchases..." />
            </ListItem>
          </List>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            3. Process for Requesting Refunds
          </Typography>
          <Typography variant="body2" paragraph>
            To request a refund, contact our customer support team...
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            4. Refund Approval and Processing
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary="Refund processed within 7-10 business days upon approval." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Refunds through the original mode of payment where possible." />
            </ListItem>
          </List>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            5. Non-Refundable Items
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary="Third-party service charges and government fees." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Fees paid to brokers, vendors, etc." />
            </ListItem>
          </List>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            6. Cancellation Policy
          </Typography>
          <Typography variant="body2" paragraph>
            Paid services may be canceled before being rendered. Refunds are subject to policy terms.
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            7. Changes to Refund Policy
          </Typography>
          <Typography variant="body2" paragraph>
            Policy updates may be made at any time and will be notified via email or app.
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2 }}>
            8. Contact Information
          </Typography>
          <Typography variant="body2" paragraph>
            For questions, contact our support team through the app or email.
          </Typography>
        </Box>

        {/* Footer Buttons */}
        <Box
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 2,
            borderTop: '1px solid rgba(0, 0, 0, 0.12)',
            backgroundColor: 'inherit'
          }}
        >
          <Button
            variant="outlined"
            fullWidth
            onClick={() => navigate('/')}
            sx={{
              color: 'text.primary',
              borderColor: 'text.primary',
              '&:hover': {
                borderColor: 'text.primary',
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={() => navigate('/')}
            sx={{
              backgroundColor: 'text.primary',
              color: 'background.paper',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.8)'
              }
            }}
          >
            I have read and accept the terms of service
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default RefundPolicy;